import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/layout/AppShell";
import Login from "@/pages/Login";
import Scheduler from "@/pages/Scheduler";
import Assets from "@/pages/Assets";
import Operators from "@/pages/Operators";
import Compliance from "@/pages/Compliance";
import Suppliers from "@/pages/Suppliers";
import Customers from "@/pages/Customers";
import DataManagement from "@/pages/DataManagement";
import DocketCapture from "@/pages/DocketCapture";
import Projects from "@/pages/Projects";
import SiteDiaryCapture from "@/pages/SiteDiaryCapture";
import WorkerSignIn from "@/pages/WorkerSignIn";
import FieldHub from "@/pages/FieldHub";
import FieldTimesheet from "@/pages/FieldTimesheet";
import Settings from "@/pages/Settings";
import ResetPassword from "@/pages/ResetPassword";
import Transport from "@/pages/Transport";
import Tenants from "@/pages/Tenants";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/docket" element={<DocketCapture />} />
            <Route path="/site-diary" element={<SiteDiaryCapture />} />
            <Route path="/sign-in" element={<WorkerSignIn />} />
            <Route path="/field" element={<FieldHub />} />
            <Route path="/my-timesheet" element={<FieldTimesheet />} />
            <Route
              path="/tenants"
              element={
                <ProtectedRoute>
                  <Tenants />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<Scheduler />} />
              <Route path="projects" element={<Projects />} />
              <Route path="assets" element={<Assets />} />
              <Route path="operators" element={<Operators />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="transport" element={<Transport />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="customers" element={<Customers />} />
              <Route path="data-management" element={<DataManagement />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
